import React from "react";
import { PolicySource } from "../type/chat";
import CitationBadge from "../components/CitationBadge";

const CITATION_REGEX = /\[(\d+)\]/;

export function parseCitationChildren(
  children: React.ReactNode,
  policySources: PolicySource[] | undefined
): React.ReactNode {
  if (!policySources || policySources.length === 0) return children;

  const sourceMap = new Map<number, PolicySource>(
    policySources.map((s) => [s.index, s])
  );

  function processNode(
    node: React.ReactNode,
    keyPrefix: string
  ): React.ReactNode {
    if (typeof node !== "string") return node;

    const parts: React.ReactNode[] = [];
    let lastIndex = 0;
    let match: RegExpExecArray | null;
    const citationRegex = new RegExp(CITATION_REGEX, "g");

    while ((match = citationRegex.exec(node)) !== null) {
      const citationIndex = parseInt(match[1], 10);
      const source = sourceMap.get(citationIndex);

      if (match.index > lastIndex) {
        parts.push(node.slice(lastIndex, match.index));
      }

      if (source) {
        parts.push(
          <CitationBadge
            key={`${keyPrefix}-cite-${citationIndex}-${match.index}`}
            index={citationIndex}
            source={source}
          />
        );
      } else {
        parts.push(match[0]);
      }

      lastIndex = match.index + match[0].length;
    }

    if (parts.length === 0) return node;
    if (lastIndex < node.length) parts.push(node.slice(lastIndex));
    return parts;
  }

  return React.Children.toArray(children).map((child, i) =>
    processNode(child, String(i))
  );
}
